import mustache from 'mustache';
import { cgSearchAutofillTemplate } from './mustache_templates';

declare global {
	interface Window {
		last_query_length:number;
	}
}

export function updateAutofillPosition(linkedTextInput: JQuery<HTMLElement>, $autofill_results: JQuery<HTMLElement>, parentScrollEl: JQuery<HTMLElement>|null) {
  // Existing logic from positionAutofill
  let offset:number = linkedTextInput.offset().top + linkedTextInput.height() + 15;
  if (parentScrollEl != null) {
    if (parentScrollEl.scrollTop() != undefined) {
      offset += parentScrollEl.scrollTop();
    };
	if (parentScrollEl.offset() != undefined) {
		offset -= parentScrollEl.offset().top;
	}
  }
  $autofill_results.parent().css("top", offset);
}

export function positionAutofill($autofill_results:JQuery<HTMLElement>,linkedTextInput:JQuery<HTMLElement> | null, parentScrollEl:JQuery<HTMLElement>|null){
	window.curAutofillInput = linkedTextInput as JQuery<HTMLInputElement>;
	updateAutofillPosition(linkedTextInput, $autofill_results, parentScrollEl);
};

export function displayAutofillSuggestions_stopByStop(predictionsHTML: string, linkedInputElement:JQuery<HTMLElement>) {
	let $autofill_results:JQuery<HTMLElement> = $("#stop-by-stop-autofill").find("#autofill_results");
	displaySuggestions_new($autofill_results, predictionsHTML, linkedInputElement);
};

export function StopByStopTrip_autofill(event: JQuery.KeyboardEventBase) {
	let currInput_query:string | null;
	currInput_query = $(event.target).val().toString();



	let linkedInputElement:JQuery<HTMLElement> = $(event.target);
	//This hides autofill results when a user clicks off. We check for that in a few places but "blur" checks some weird edge cases making it function a lot more fluidly
	$(".autofillOuterWrap").on("blur", function(){
		$("#autofill_results").hide();
	});

	if (event.key != "Enter" && event.key != "Escape" && event.key != "Tab") {
		$(event.target).removeAttr("query_val");
		$(event.target).removeAttr("query_type");
		// if (event.key != "Escape" && event.key != "Tab") {
			let $autofill_results:JQuery<HTMLElement> = $("#stop-by-stop-autofill").find("#autofill_results");
			if ($autofill_results.hasClass("d-none")) $autofill_results.removeClass("d-none");
			$autofill_results.parent().show();
			$autofill_results.show();
			getSearchSuggestions(currInput_query).then(response => {
				displayAutofillSuggestions_stopByStop(response, linkedInputElement);
			}).catch(e => {
				console.error(e);
				// const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
				// $("#errorModal").modal("show");
			});
		return;
	} else {
		//hide autofill suggestions when user presses ESC or TAB or ENTER
		$("#stop-by-stop-autofill").find("#autofill_results").addClass("d-none");
	};
};

/*
 * appends predictionsHTML to autofill element
 * if autofill element hidden, shows it
 * adds event listener to set query_type, query_val attributes to linkedTextInput element when user clicks on an autofill suggestion
 */
export function displaySuggestions_new($autofill_results:JQuery<HTMLElement>,predictionsHTML: string, linkedTextInput:JQuery<HTMLElement> | null) {

	$autofill_results.html(predictionsHTML.trim());
	if (predictionsHTML.trim().length) {
		$("#user-locations-wrapper").hide();
	} else {
		$("#user-locations-wrapper").show();
	}
	// if ($autofill_results.hasClass("d-none")) $autofill_results.removeClass("d-none");

	//length checks that the element exists
	//this if statement is to fix trip planner autofill placement
	// if($('#tripStopInfoSidebar').length && $('#tripStopInfoSidebar').is(":visible")){
	// 	if(linkedTextInput.attr("id") == "addLegInput"){
	// 		let autoFillWrap:JQuery<HTMLElement> = $autofill_results.parent();
	// 		let new_autoFillWrap:JQuery<HTMLElement> = autoFillWrap.clone();
	// 		autoFillWrap.remove();
	// 		$("#addLegModal").find(".modal-content").append(new_autoFillWrap);
	// 		$autofill_results = new_autoFillWrap.find("#autofill_results");
	// 		$autofill_results.parent().css("top", linkedTextInput.offset().top - $("#addLegModal").find(".modal-content").offset().top - linkedTextInput.height() - 15);
	// 	}else{
	// 		positionAutofill($autofill_results, linkedTextInput,$("#tripStopInfoSidebar"));
	// 		$autofill_results.parent().css("left", linkedTextInput.offset().left);
	// 	}
	// }else{
	// 	positionAutofill($autofill_results, linkedTextInput, $("#tripStopInfoSidebar"));
	// 	//$autofill_results.parent().css("left", linkedTextInput.offset().left);
	// }

	if($autofill_results.attr("genieTripInput") != undefined) {
		$autofill_results.parent().css("top", linkedTextInput.offset().top - $('#takeGenieTrip_modal_content').offset().top - (linkedTextInput.height()+15));
	}

	$autofill_results.find(".search-suggestion").on("click", function(event) {
		let suggested_search_el = event.target;
		let suggested_search:string = suggested_search_el.innerHTML.replace(/&amp;/g,'&');
		linkedTextInput.val(suggested_search);
		linkedTextInput.attr("query_type", $(this).attr("query_type"));
		linkedTextInput.attr("query_val", $(this).attr("query_val"));
		linkedTextInput.trigger("focus");

		$("#autofill_results").hide();
		$("#stop-by-stop-autofill").hide();
		$("#user-locations-wrapper").show();
	});

	// $autofill_results.parent().show();
	// $autofill_results.show();
};

/*
 * defunct
 */
export function displaySearchSuggestions($autofill_results:JQuery<HTMLElement>,predictions:Array<string>) {
	$autofill_results.html("");
	if ($autofill_results.hasClass("d-none")) $autofill_results.removeClass("d-none");

	//FIXME: autofill suggestions not displaying properly
	for (var prediction of predictions) {
		//TODO: work with Jake to make this AutofillTemplate nice
		let $div = $(mustache.render(cgSearchAutofillTemplate,prediction));
		$($div).appendTo($autofill_results);

	};

};

/*
 * gets element for cgSearch & calls function to display predictions, set up event listeners
 */
export function displayAutofillSuggestions_cgSearch(predictions: Array<string>) {
	if (!predictions){
		return;
	}
	let $autofill_results:JQuery<HTMLElement> = $("#autofill_results");
	displaySearchSuggestions($autofill_results,predictions)
};

//get search suggestions from azure (campground search)
export const getSearchSuggestions = async(query:string) => {
	let response:string;
  	let success:boolean = false;
  	let errMsg:string;

	//if no query, return empty string to clear search suggestions
	if (query.length < 1) {
		$("#user-locations-wrapper").show();
		return ""
	};


	//call campground_search_suggest (project/search/routes.py)
	await $.ajax({
		type:"post",
		url: "/campground_search_suggest",
		data: JSON.stringify({query:query}),
		contentType:"application/json",
		dataType: "html",
		success: (data) => {response=data;success=true;},
		error: (xhr,errStr,exc) => {errMsg=errStr;}
	});

	//return html of search suggestions (string)
	return new Promise<string>((resolve,reject) => {
		if (success) resolve(response);
		else reject (Error(errMsg));
	});

};

//get search suggestions from azure (campground search) - CIU = campground info update
//seperate function that will only return campground suggestions
export const getSearchSuggestions_CIU = async(query:string) => {
	let response:string;
	let success:boolean = false;
	let errMsg:string;

	//if no query, return empty string to clear search suggestions
	if (query.length < 1) {
		return ""
	};

	//get updated autofill suggestions from google api based on new user text
	// trying autofill on every character since it's from SQL now
	if (! window.last_query_length) window.last_query_length = query.length - 3;
	if (Math.abs(query.length - window.last_query_length ) > 0) {

		//call campground_search_suggest (project/search/routes.py)
		await $.ajax({
		  type:"post",
		  url: "/campground_search_suggest_CIU",
		  data: JSON.stringify({query:query}),
		  contentType:"application/json",
		  dataType: "html",
		  success: (data) => {response=data;success=true;},
		  error: (xhr,errStr,exc) => {errMsg=errStr;}
		});

		window.last_query_length = query.length;

		//return html of search suggestions (string)
		return new Promise<string>((resolve,reject) => {
		  if (success) resolve(response);
		  else reject (Error(errMsg));
		});

	};
};